module.exports = __webpack_public_path__ + "img/合肥地址切图.93ae7d17.jpg";